import React from "react";

const DemoModeBanner = () => (
  <div
    className="rounded-lg border border-primary/30 bg-primary/10 px-4 py-3 text-sm text-foreground"
    role="status"
  >
    <p className="font-medium">Modo demonstração</p>
    <p className="mt-1 text-muted-foreground">
      Preencha o formulário e veja a prévia ao lado. Os dados ficam apenas no
      seu navegador até você criar uma conta. Para gerar o PDF, cadastre-se
      gratuitamente.
    </p>
  </div>
);

export default DemoModeBanner;
